import AuthFormFields from './authFormFields'

export const AuthFormModel = {
  formId: 'auth-form',
  formFields: {
    ...AuthFormFields,
  },
}
